export default __webpack_public_path__ + "static/media/pontevedra.c402daa4.jpg";